// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDZQdIwkufZlB2Aednzgu_-8BTsUA2DyWY",
    authDomain: "cpc-dev4.firebaseapp.com",
    databaseURL:
      "https://cpc-dev4-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "cpc-dev4",
    storageBucket: "cpc-dev4.appspot.com",
    messagingSenderId: "99519111929",
    appId: "1:99519111929:web:4ce363e66f50b183127828",
  },
  userApi: "https://europe-west1-cpc-dev4.cloudfunctions.net/api",
  frontEndApi: "https://{1}.powertrack.porsevej.dk",
  serverName: "dev4",
  app_type: "powertrack",
  app_mode: "normal",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
